import { GenericSvg } from '../../assets/svgs/GenericSVG';
import { MainButton } from '../../components/buttons/MainButton';
import { LoadingSpinner } from '../../components/loading/LoadingSpinner';
import { PageContainer, PageContentContainer } from '../../components/PageContainer';
import { InfoText } from '../../components/texts/InfoText';
import { colors } from '../../styles/colors';
import { useHandleVerifyEmail } from './utils/useHandleVerifyEmail';

export const AppUserEmailVerification = () => {
  const { emailVerificationStatus, startVerification } = useHandleVerifyEmail();

  const { title, subtitle, icon } = {
    IDLE: {
      title: 'E-Mail Verifizierung',
      subtitle: ['Klicke bitte hier um deine E-Mail Adresse für die Physiofit App zu bestätigen.'],
      icon: null,
    },
    PENDING: {
      title: 'E-Mail Verifizierung',
      subtitle: ['Deine E-Mail-Adresse wird verifiziert. Das dauert nur einen Moment.'],
      icon: <LoadingSpinner color={colors.primary} size={100} />,
    },
    SUCCESS: {
      title: 'E-Mail erfolgreich verifiziert',
      subtitle: [
        'Deine E-Mail-Adresse wurde erfolgreich verifiziert. Du kannst jetzt alle Funktionen der Physiofit-App nutzen.',
        'Schließe dieses Fenster und kehre zur Physiofit-App zurück.',
      ],
      icon: <GenericSvg name="Checkmark" width={100} height={100} primaryColor={colors.success} />,
    },
    INVALID_URL: {
      title: 'E-Mail Verifizierung fehlgeschlagen',
      subtitle: [
        'Wir konnten deine E-Mail-Adresse nicht verifizieren. Der Verifizierungslink ist möglicherweise ungültig oder abgelaufen.',
        'Bitte fordere die Verifizierung in der App erneut an oder wende dich an unseren Support in der Physiofit-App.',
      ],
      icon: <GenericSvg name="Close" width={100} height={100} primaryColor={colors.lightRed} />,
    },
  }[emailVerificationStatus];

  return (
    <PageContainer>
      <PageContentContainer>
        <InfoText headline={title} text={subtitle} />
      </PageContentContainer>
      {icon}
      {emailVerificationStatus === 'IDLE' && (
        <MainButton text="E-Mail-Adresse bestätigen" onClick={startVerification} />
      )}
    </PageContainer>
  );
};
